import { Col, FormFeedback, Row } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import { useEffect } from "react";

export const PolicyDetails = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  getPolicyData,
  isEdit,
}) => {
  useEffect(() => {
    values.policyName = getPolicyData?.name || "";
    values.priority = getPolicyData?.precedence || "";
  }, [getPolicyData]);
  return (
    <div className="border p-4 mt-2">
      <Row className="gy-4 ">
        <Col xxl={4} md={4}>
          <LabelText
            displayText={"Policy Name "}
            important={" *"}
            classLabelName={"ms-0 rv-form-label"}
            className={"text-danger"}
          />
          <LabelText
            htmlFor={"policyName"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.policyName && errors.policyName
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.policyName && errors.policyName
                ? errors.policyName
                : "Enter Policy Name"
            }
          />
          <div className="flex-column ">
            <InputField
              name={"policyName"}
              type={"text"}
              className={" mb-0 form-control policy-name-input-length"}
              id={"policyName"}
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values?.policyName}
              invalid={touched.policyName && errors.policyName ? true : false}
            />
          </div>
        </Col>
        <Col xxl={4} md={4}>
          <LabelText
            displayText={"Priority "}
            important={" *"}
            classLabelName={"ms-0 rv-form-label"}
            className={"text-danger"}
          />
          <LabelText
            htmlFor={"priority"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.priority && errors.priority
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.priority && errors.priority
                ? errors.priority
                : "Enter Priority"
            }
          />
          <div className=" flex-column ">
            <InputField
              name="priority"
              type="text" // <- use text to stop native number scroll
              className="mb-0 form-control policy-name-input-length"
              id="priority"
              handleChange={(e) => {
                // allow only numbers
                const value = e.target.value.replace(/\D/g, "");
                handleChange({ target: { name: "priority", value } });
              }}
              handleBlur={handleBlur}
              value={values.priority}
              invalid={touched.priority && errors.priority ? true : false}
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown")
                  e.preventDefault();
              }}
            />
          </div>
        </Col>
        {isEdit && (
          <Col xxl={4} md={4}>
            <LabelText displayText={`Policy ID `} classLabelName={"d-block"} />
            <LabelText
              displayText={`- `}
              classLabelName={"d-block rv-label-muted "}
            />
            <LabelText
              displayText={`${getPolicyData.id}`}
              classLabelName={"d-block policy-id-text"}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};
